import { render } from "./Contact.vue?vue&type=template&id=4a603d2a"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=4a603d2a&lang=css"
script.render = render

export default script